import React from 'react'
import Form from 'react-bootstrap/Form'


export default class NumberPicker extends React.Component { 
	constructor(props) { 
		super(props)
		this.state = { 
			value : '0'
		}
	}

	handleStateChange(newVal) { 
		this.props.onChange(newVal)
		this.setState({value: newVal})
	}


	getOptions() { 
		var max = 0
		if (this.props.max == undefined && this.props.max == null) { 
			max = 1
		} else { 
			max = this.props.max
		}
		
		const numbers = []
		for (var i = 0; i < max + 1; i++) { 
				numbers.push(<option key={i}>{i}</option>)
		}
		return numbers
	}

	render() { 
		return (
			<Form className="number_picker">
				<Form.Group controlId="selectPicker">
				<Form.Control as="select"
				value={this.state.value}
				onChange={(e)=>this.handleStateChange(e.target.value)} >
				{this.getOptions()}
				</Form.Control>
				</Form.Group>
			</Form>
			)
	}
}